//const $ = require("../../node_modules/jquery/dist/jquery.min");
require("../../node_modules/jquery-ui/ui/core");
require("../../node_modules/jquery-ui/ui/widget");
require("../../node_modules/jquery-ui/ui/widgets/mouse");
require("../../node_modules/jquery-ui/ui/widgets/slider");
require("jquery-ui-touch-punch");

module.exports = {
  init: () => {
    $(".slider").slider({
      range: true,
      min: 0,
      max: 1000000,
      step: 100,
      values: [300000, 1000000],
      slide: function(event, ui) {
        $(".slider-label-item--low span").text(formatNumber(ui.values[0]));
        $(".slider-label-item--high span").text(formatNumber(ui.values[1]));
      }
    });

    $(".slider-label-item--low span").text(formatNumber($(".slider").slider("values", 0)));
    $(".slider-label-item--high span").text(formatNumber($(".slider").slider("values", 1)));

    function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }
  }
};
